import { MuiDialog } from '@/shared/ui';

import { Z_INDEX } from '@/config/z-index';
import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

import { MonthlyRecapArticleDialog } from './MonthlyRecapArticleDialog';

type MonthlyRecapArticleModalProps = {
  article: MonthlyRecapsArticle;
  onClose: () => void;
};

export const MonthlyRecapArticleModal = ({ article, onClose }: MonthlyRecapArticleModalProps) => (
  <MuiDialog
    disableAutoFocus
    fullScreen
    open
    slotProps={{
      paper: {
        sx: {
          backgroundColor: 'gx.mainBackground',
          display: 'flex',
          flexDirection: 'column'
        }
      },
      backdrop: { sx: { backgroundColor: 'rgba(18, 22, 63, 0.80)' } }
    }}
    sx={{ zIndex: Z_INDEX.dialog }}
    onClose={onClose}
  >
    <MonthlyRecapArticleDialog
      article={article}
      onBack={onClose}
      onClose={onClose}
    />
  </MuiDialog>
);
